module.exports = __webpack_public_path__ + "static/media/google-download.3ebf6b6c.svg";